import React, {useContext} from 'react'
import {
  Typography,
  Button,
  Switch,
  Divider,
  IconButton,
  Collapse,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import './ReservationConfiguration.scss'
import '../../styles/Reservation/Reservation.scss'
import ReservationApprovalManager from '../ReservationApprovalManager'
import HoldTimeInput from './HoldTimeInput'
import ReservationLimitReservable from '../ReservationLimitReservable'
import ActionSteps from './ActionSteps'
import {ReservationConfigurationContext} from '../../context/ReservationConfiguration'
import {useParams} from 'react-router'
import ReservationAdditionalFields from '../ReservationAdditionalFields/ReservationAdditionalFields'
import FieldTypeLookup from '../ReservationAdditionalFields/FieldTypeLookup.json'
import _ from 'lodash'
import CloseIcon from '@material-ui/icons/Close'
import {ToastMessageContext} from '../../context/ToastMessage/ToastMessage'
import {UserContext} from '../../context/User'
import PurchaseReservationPopup from './PurchaseReservationPopup'
import Cookies from 'js-cookie'

import imgCriteriaHelper from '../../assets/images/reservation-criteria_helper.png'
import LoadingIndicator from './LoadingIcon'
import {transformForSave} from './util'
import StatusSelect from './StatusSelect'
import BlockingLoader from './BlockingLoader'
import ReservationErrorBoundary from '../ReservationErrorBoundary'
import {useModal} from '../../common/Modal'
const RootClass = 'reservation-configuration'
const ReservationConfiguration = () => {
  const leaveModal = useModal('simple', {
    scheme: 'warning',
    title: 'Save changes before leaving?',
    description: 'Your changes will be lost if you don’t save them. ',
    buttons: {
      cancel: {
        label: 'Cancel',
      },
      negative: {
        label: "Don't Save",
      },
      affirmative: {
        label: 'Yes',
      },
    },
  })
  const {
    group,
    getGroup,
    postConfiguration,
    getConfiguration,
    pconfiguration,
    gconfiguration: _configuration,
  } = React.useContext(ReservationConfigurationContext)
  const {group_id} = useParams()
  const ctxToast = React.useContext(ToastMessageContext)
  const [configuration, setConfiguration] = React.useState({
    active: false,
    managerIds: [],
    managerTemplateIds: [],
    holdTime: 0,
    unitTime: 'hours',
    limitReservable: [], //{field_id: 3212, value: ['test 5', 'test 2']}
    action_steps: [],
    additional_criteria: [],
    action_step_statuses: [],
    additional_fields: [],
  })

  const currentUser = useContext(UserContext)
  const [purchaseShow, setPurchaseShow] = React.useState(false)
  // unedited config
  const [prevConfiguration, setPrevConfiguration] = React.useState(_.cloneDeep(configuration))
  const [refBtnSave, setRefBtnSave] = React.useState(null)

  const [isCollapsedAdvSettings, SetIsCollapsedAdvSettings] = React.useState(true)
  const [modal, setModal] = React.useState({modal: '', params: {}})
  const [redirectUrl, setRedirectUrl] = React.useState()
  const [saveSuccessMessage, setSaveSuccessMessage] = React.useState('')
  const [saveLoaderMessage, setSaveLoaderMessage] = React.useState('')

  const handleSelectAdditionalCriteria = (e, value) => {
    setConfiguration({...configuration, additional_criteria: value})
  }

  const handleActionStepStatuses = (e, value) => {
    setConfiguration({...configuration, action_step_statuses: value})
  }

  const handleClickApprovalManager = e => {
    window.parent.postMessage(
      'focusScreen',
      `${process.env.REACT_APP_BARCODE_WINDOW_URL}/${group_id}/reservation_configuration`
    )
    setModal({modal: 'approval_manager', params: {}})
  }
  const handleCloseModal = e => {
    setModal({modal: '', params: {}})
  }
  const handleSaveApprovalManager = (e, managerIds, managerTemplateIds) => {
    setConfiguration({...configuration, managerIds, managerTemplateIds})
    setModal({modal: '', params: {}})
  }
  const handleChangeHoldTime = (e, v) => {
    setConfiguration({...configuration, ...v})
  }

  const handleClickLimitReservable = e => {
    window.parent.postMessage(
      'focusScreen',
      `${process.env.REACT_APP_BARCODE_WINDOW_URL}/${group_id}/reservation_configuration`
    )
    setModal({modal: 'limit_reservable', params: {}})
  }
  const handleSaveLimitReservable = (e, limitReservable) => {
    setConfiguration({...configuration, limitReservable})

    setModal({modal: '', params: {}})
  }
  const handleChangeActionSteps = (e, steps) => {
    setConfiguration({...configuration, action_steps: steps})
  }

  const handleSave = e => {
    const data = transformForSave(
      {
        ...configuration,
        entity_id: group_id,
        account_id: localStorage.account_id,
        user_id: localStorage.user_id,
      },
      prevConfiguration
    )
    const value = data.id
    Cookies.remove('filters_removed_' + value)
    setRefBtnSave(e.target)
    setSaveLoaderMessage('Saving...')
    setSaveSuccessMessage('Configuration saved.')
    postConfiguration(data)
  }

  const handleClickAdditionalFields = e => {
    window.parent.postMessage(
      'focusScreen',
      `${process.env.REACT_APP_BARCODE_WINDOW_URL}/${group_id}/reservation_configuration`
    )
    setModal({modal: 'additional_fields', params: {}})
  }

  const handleEditAdditionalField = (e, data, index) => {
    const value_data_id = data.id
    if (Cookies.get('filters_removed_' + value_data_id)) {
      const cookieValue = Cookies.get('removed_filter_savedResponse_' + value_data_id)
      const decodedCookieValue = decodeURIComponent(cookieValue)
      const cookieObject = JSON.parse(decodedCookieValue)

      setModal({
        modal: 'additional_fields',
        params: {edit: true, data: cookieObject.data, index: index},
      })
    } else {
      setModal({modal: 'additional_fields', params: {edit: true, data: data, index: index}})
    }
  }

  const handleDeleteAdditionalField = (e, index) => {
    e.stopPropagation()
    const _fields = [...configuration.additional_fields]
    _fields.splice(index, 1)
    setConfiguration({...configuration, additional_fields: [..._fields]})
  }

  const handleSaveAdditionalFields = (e, field, index = null) => {
    const _fields = [...configuration.additional_fields]
    if (index === null) {
      setConfiguration({...configuration, additional_fields: [..._fields, field]})
    } else {
      _fields[index] = field
      setConfiguration({...configuration, additional_fields: [..._fields]})
    }
    const isOpenCookie = Cookies.get('isApplied')
    const isChanged = Cookies.get('isChanged')

    if (isOpenCookie === 'true' && isChanged === 'true') {
      for (const key in field.list_filters_attributes) {
        if (field.list_filters_attributes.hasOwnProperty(key)) {
          const item = field.list_filters_attributes[key]
          const typeId = item.fieldType?.id
          if (typeId !== undefined) {
            item.field_id = typeId
          }
        }
      }
    }
    setModal({modal: '', params: {}})
  }

  const handleClosePurchaseModal = e => {
    setPurchaseShow(false)
  }

  const handleToggleEnabled = evt => {
    const _configuration = {...configuration, active: !configuration.active}
    setPurchaseShow(false)

    if (_configuration.active) {
      if (currentUser.details.reservation_enabled) {
        setConfiguration(_configuration)
        const data = transformForSave(
          {
            ..._configuration,
            entity_id: group_id,
            account_id: localStorage.account_id,
            user_id: localStorage.user_id,
          },
          prevConfiguration
        )
        if (!_.isEmpty(configuration.action_steps)) {
          setSaveLoaderMessage('Turning on...')
          setSaveSuccessMessage('Reservations is turned on')
          postConfiguration(data)
        }
      } else {
        setPurchaseShow(true)
      }
    }
    // means going to inactive
    if (!_configuration.active) {
      if (_.isEqual(configuration, prevConfiguration)) {
        setConfiguration(_configuration)
        const data = transformForSave(
          {
            ..._configuration,
            entity_id: group_id,
            account_id: localStorage.account_id,
            user_id: localStorage.user_id,
          },
          prevConfiguration
        )
        setSaveLoaderMessage('Turning off...')
        setSaveSuccessMessage('Reservations is turned off')
        postConfiguration(data)
        return
      }

      if (!_.isEqual(_.omit(configuration, ['active']), _.omit(prevConfiguration, ['active']))) {
        if (leaveModal) {
          leaveModal.show({
            buttons: {
              cancel: {
                label: 'Cancel',
              },
              negative: {
                label: "Don't Save",
                click: (d, modal) => {
                  if (!_.isEmpty(prevConfiguration)) {
                    const data = transformForSave(
                      {
                        ...prevConfiguration,
                        active: !configuration.active,
                        entity_id: group_id,
                        account_id: localStorage.account_id,
                        user_id: localStorage.user_id,
                      },
                      prevConfiguration
                    )
                    setSaveLoaderMessage('Turning off...')
                    setSaveSuccessMessage('Reservations is turned off')
                    postConfiguration(data)
                  }
                  setConfiguration({...prevConfiguration, active: !configuration.active})
                  modal.hide()
                }, //overrides default behavior
              },
              affirmative: {
                label: 'Yes',
                click: (d, modal) => {
                  setConfiguration(_configuration)
                  const data = transformForSave(
                    {
                      ..._configuration,
                      entity_id: group_id,
                      account_id: localStorage.account_id,
                      user_id: localStorage.user_id,
                    },
                    prevConfiguration
                  )
                  setSaveLoaderMessage('Turning off...')
                  setSaveSuccessMessage('Reservations is turned off')
                  postConfiguration(data)
                  modal.hide()
                }, //overrides default behavior
              },
            },
          })
        }
        return
      }
      setConfiguration(_configuration)
    }
  }

  const handleClickNotification = evt => {
    if (_.isEqual(configuration, prevConfiguration)) {
      window.open(`${localStorage.parent_origin}/account/notifications`, '_top')
      return
    }

    if (leaveModal) {
      leaveModal.show({
        buttons: {
          cancel: {
            label: 'Cancel',
          },
          negative: {
            label: "Don't Save",
            click: (data, modal) => {
              window.open(`${localStorage.parent_origin}/account/notifications`, '_top')
              modal.hide()
            }, //overrides default behavior
          },
          affirmative: {
            label: 'Yes',
            click: (data, modal) => {
              handleSave(evt)
              setRedirectUrl(`${localStorage.parent_origin}/account/notifications`)
              modal.hide()
            }, //overrides default behavior
          },
        },
      })
    }
  }

  const handleClickUserPermissions = evt => {
    if (_.isEqual(configuration, prevConfiguration)) {
      window.open(`${localStorage.parent_origin}/account/template_rules`, '_top')
      return
    }

    if (leaveModal) {
      leaveModal.show({
        buttons: {
          cancel: {
            label: 'Cancel',
          },
          negative: {
            label: "Don't Save",
            click: (data, modal) => {
              window.open(`${localStorage.parent_origin}/account/template_rules`, '_top')
              modal.hide()
            }, //overrides default behavior
          },
          affirmative: {
            label: 'Yes',
            click: (data, modal) => {
              handleSave(evt)
              setRedirectUrl(`${localStorage.parent_origin}/account/template_rules`)
              modal.hide()
            }, //overrides default behavior
          },
        },
      })
    }

    //
  }

  const handleCancel = evt => {
    if (_.isEqual(configuration, prevConfiguration)) {
      window.open(`${localStorage.parent_origin}/entities`, '_top')
      return
    }

    if (leaveModal) {
      // Check if there are additional fields with list_filters_attributes
      if (configuration.data.additional_fields && configuration.data.additional_fields.length > 0) {
        configuration.data.additional_fields.forEach(field => {
          if (field.list_filters_attributes && Array.isArray(field.list_filters_attributes)) {
            field.list_filters_attributes.forEach(filter => {
              const value = filter.field_id
              Cookies.remove('filters_removed_' + value)
            })
          }
        })
      }
      leaveModal.show({
        buttons: {
          cancel: {
            label: 'Cancel',
          },
          negative: {
            label: "Don't Save",
            click: (data, modal) => {
              window.open(`${localStorage.parent_origin}/entities`, '_top')
              modal.hide()
            },
          },
          affirmative: {
            label: 'Yes',
            click: (data, modal) => {
              handleSave(evt)
              setRedirectUrl(`${localStorage.parent_origin}/entities`)
              modal.hide()
            },
          },
        },
      })
    }
  }

  // use Effect

  React.useEffect(() => {
    // load status on mount
    getGroup({group_id: group_id})

    // load configuration{group_id: group_id}
    getConfiguration({group_id: group_id})

    // eslint-disable-next-line
  }, [])

  React.useEffect(() => {
    const {data} = _configuration
    if (_.isEmpty(data)) {
      return
    }
    let config = {
      active: data.active,
      managerIds: data.manager_ids || [],
      managerTemplateIds: data.manager_template_ids || [],
      holdTime: data.hold_time || 0,
      unitTime: data.unit_time || 'hours',
      limitReservable: data.limit_reservable || [],
      action_steps: (data.action_steps || []).map(e => ({
        action_id: e.action_id,
        blocked_by_reservation_action_ids: e.blocked_by_reservation_action_ids || [],
        return_field_data: e.return_field_data,
      })),
      additional_criteria: (data.optional_status || []).map(s => parseInt(s)),
      action_step_statuses: (data.action_status || []).map(s => parseInt(s)),
      additional_fields: (data.additional_fields || [])
        .filter(e => e.is_open_field === true)
        .map(e => ({
          id: e.id,
          name: e.name,
          type: e.type,
          is_required: e.is_required,
          is_open_field: e.is_open_field,
          ...e,
        })),
    }

    setPrevConfiguration(_.cloneDeep(config))
    setConfiguration(config)

    // eslint-disable-next-line
  }, [_configuration])

  React.useEffect(() => {
    if (!!currentUser.details && !!_configuration.data) {
      if (!currentUser.details.reservation_enabled && _configuration.data.active) {
        const _configuration = {...configuration, active: false}
        setConfiguration(_configuration)
        const data = transformForSave(
          {
            ..._configuration,
            entity_id: group_id,
            account_id: localStorage.account_id,
            user_id: localStorage.user_id,
          },
          prevConfiguration
        )
        postConfiguration(data)
      }
    }
    // eslint-disable-next-line
  }, [currentUser])

  // redirect to other url
  // todo: change this to handle url instead
  React.useEffect(() => {
    if (pconfiguration.isLoading) return

    if (_.isEmpty(pconfiguration.errors) && !_.isEmpty(pconfiguration.data)) {
      if (!!redirectUrl) {
        setTimeout(() => {
          window.open(redirectUrl, '_top')
        }, 1000)
      }

      if (!_.isEmpty(currentUser) && currentUser.details.reservation_enabled) {
        ctxToast.popMessage(saveSuccessMessage || 'Configuration saved.', 'success', null)
      }
      window.parent.postMessage(
        'scrollTop',
        `${process.env.REACT_APP_BARCODE_WINDOW_URL}/${group_id}/reservation_configuration`
      )
    }
    if (!_.isEmpty(pconfiguration.errors)) {
      _.each(pconfiguration.errors, e => {
        ctxToast.popMessage(e[0], 'error', null)
        window.parent.postMessage(
          'scrollTop',
          `${process.env.REACT_APP_BARCODE_WINDOW_URL}/${group_id}/reservation_configuration`
        )
      })
    }
    // saving
    let update_fields = {}
    // set additional fields
    if (!pconfiguration.errors?.additional_fields && pconfiguration.data.additional_fields) {
      update_fields['additional_fields'] = (pconfiguration.data.additional_fields || [])
        .filter(e => e.is_open_field === true)
        .map(e => ({
          id: e.id,
          name: e.name,
          type: e.type,
          is_required: e.is_required,
          is_open_field: e.is_open_field,
          ...e,
        }))
    }
    // set action steps
    if (!pconfiguration.errors?.action_steps && pconfiguration.data.action_steps) {
      update_fields['action_steps'] = pconfiguration.data.action_steps.map(e => ({
        action_id: e.action_id,
        return_field_data: e.return_field_data,
      }))
    }
    if (!_.isEmpty(update_fields)) {
      const _temp = {
        ...configuration,
        ...update_fields,
      }
      setConfiguration(_temp)
      setPrevConfiguration(_temp)
    }

    // don't include popMessage in dependencies to avoid infinite loop
    // eslint-disable-next-line
  }, [
    pconfiguration.isLoading,
    pconfiguration.data,
    pconfiguration.errors,
    redirectUrl,
    refBtnSave,
    saveSuccessMessage,
  ])

  const limitReservableCount = React.useMemo(() => {
    let count = 0
    _.each(configuration.limitReservable, e => (count += e.value.length))
    return count
  }, [configuration.limitReservable])

  const getActionStepsOptions = (statuses, additionalFields) => {
    let optionsArray = statuses.map(status => {
      let disabled = false
      additionalFields.map(af => {
        if (status.id === af) {
          disabled = true
        }
        return true
      })
      status = {...status, isDisabled: disabled}
      return status
    })
    return optionsArray
  }

  return (
    <ReservationErrorBoundary errors={!!_configuration.errors && []}>
      <div className={`${RootClass} c-res-mod`}>
        <div className={`ap-header`}>
          <div className={`ap-header__container`}>
            <Typography className="ap-header__title">
              Reservations -{' '}
              <span className="ap-header__title ap-header__title--light">{group.data?.name}</span>
            </Typography>

            <Switch
              className={`${RootClass}__header-switch`}
              color="primary"
              name="checkedB"
              inputProps={{'aria-label': 'primary checkbox'}}
              checked={configuration.active}
              onClick={handleToggleEnabled}
            />
          </div>

          <div
            className={`ap-header__container ap-header__container--right ${!configuration.active &&
              'ap-disabled'}`}
          >
            <Button onClick={handleClickNotification} className="ap-header__button">
              Notification
            </Button>
            <Button onClick={handleClickUserPermissions} className="ap-header__button">
              User Permissions
            </Button>
          </div>
        </div>

        <div className={`ap-section ${!configuration.active && 'ap-disabled'}`}>
          <div className={`ap-section__header`}>
            <Typography className={`ap-section__title`}>Basic Settings</Typography>
          </div>
          <Divider className={`ap-section__h-divider`} />

          <div className={`ap-section__container`}>
            <div className={`${RootClass}__basic-panel ${RootClass}__basic-panel--left`}>
              <Typography className={`ap-section__title ap-section__title--sm`}>
                Action Steps
              </Typography>
              <Typography className={`ap-section__description`}>
                Determine what actions occur on outgoing reservations and returns.
              </Typography>
              <ActionSteps steps={configuration.action_steps} onChange={handleChangeActionSteps} />
            </div>
            <div className={`${RootClass}__basic-panel`}>
              <Typography className={`ap-section__title ap-section__title--sm`}>
                Status for Action Steps
              </Typography>
              <Typography className={`ap-section__description`}>
                What status does an item have to be in to perform Action Steps.
              </Typography>
              <Typography className={`ap-section__title ap-section__title--xs`}>
                Select Status
              </Typography>
              {group.isLoading && <LoadingIndicator style={{width: 200}} />}

              {!group.isLoading && (
                <StatusSelect
                  options={
                    group.data?.statuses
                      ? getActionStepsOptions(
                          group.data?.statuses,
                          configuration.additional_criteria
                        )
                      : []
                  }
                  onChange={handleActionStepStatuses}
                  value={configuration.action_step_statuses}
                />
              )}

              <Divider
                className={`ap-section__h-divider ap-section__h-divider--thin`}
                style={{
                  marginTop: 24,
                  marginBottom: 16,
                }}
              />

              <Typography className={`ap-section__title ap-section__title--sm`}>
                Additional Reservation Criteria
              </Typography>
              <Typography className={`ap-section__description`}>
                What statuses would prevent a reservation.
              </Typography>
              <Typography className={`ap-section__title ap-section__title--xs`}>
                Select Status
              </Typography>
              <div style={{position: 'relative'}}>
                {group.isLoading && <LoadingIndicator style={{width: 200}} />}
                {!group.isLoading && (
                  <StatusSelect
                    options={
                      group.data?.statuses
                        ? getActionStepsOptions(
                            group.data?.statuses,
                            configuration.action_step_statuses
                          )
                        : []
                    }
                    onChange={handleSelectAdditionalCriteria}
                    value={configuration.additional_criteria}
                  />
                )}
                <img
                  src={imgCriteriaHelper}
                  className="reservation-criteria-helper"
                  alt="sample timeline"
                />
                <div className={`ap-big-bubble`}>
                  <Typography className={`ap-section__description`} style={{marginBottom: 3}}>
                    Reservations are prevented if:
                  </Typography>
                  <Typography className={`ap-section__title ap-section__title--xs`}>
                    {configuration.additional_criteria
                      .map(c => (group.data?.statuses || []).find(status => status.id === c)?.name)
                      .join(', ')}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`ap-section ${!configuration.active && 'ap-disabled'}`}>
          <div
            className={`ap-section__header`}
            onClick={() => SetIsCollapsedAdvSettings(!isCollapsedAdvSettings)}
          >
            <Typography className={`ap-section__title`}>View Advanced Settings</Typography>
            <IconButton size="small" className={`ap-icon-button`}>
              {!isCollapsedAdvSettings && <ExpandMoreIcon />}
              {isCollapsedAdvSettings && <KeyboardArrowLeftIcon />}
            </IconButton>
          </div>
          <Divider className={`ap-section__h-divider`} />
          <Collapse in={!isCollapsedAdvSettings} timeout="auto" unmountOnExit>
            <div className={`ap-section__container`}>
              <div className={`${RootClass}__advance-panel ${RootClass}__advance-panel--left`}>
                <div className={`ap-action-field`}>
                  <div className={`ap-action-field__panel`}>
                    <Typography className={`ap-section__title ap-section__title--sm`}>
                      Reservation Hold Time
                    </Typography>
                    <Typography className={`ap-section__description`}>
                      Set how long the system holds onto an item before releasing the reservation.
                    </Typography>
                  </div>
                  <div className={`ap-action-field__panel ap-action-field__panel--right`}>
                    <HoldTimeInput
                      value={{holdTime: configuration.holdTime, unitTime: configuration.unitTime}}
                      onChange={handleChangeHoldTime}
                    />
                  </div>
                </div>
                <Divider
                  className={`ap-section__h-divider ap-section__h-divider--thin`}
                  style={{
                    marginTop: 24,
                    marginBottom: 16,
                  }}
                />
                <div className={`ap-action-field`}>
                  <div className={`ap-action-field__panel`}>
                    <Typography className={`ap-section__title ap-section__title--sm`}>
                      Limit Reservable Items
                    </Typography>
                    <Typography className={`ap-section__description`}>
                      Set your criteria for what can be reserved.
                    </Typography>
                  </div>
                  <div className={`ap-action-field__panel ap-action-field__panel--right`}>
                    <Button onClick={handleClickLimitReservable} className={`${RootClass}__button`}>
                      {limitReservableCount ? `Edit (${limitReservableCount})` : 'Add'}
                    </Button>
                  </div>
                </div>
                <Divider
                  className={`ap-section__h-divider ap-section__h-divider--thin`}
                  style={{
                    marginTop: 24,
                    marginBottom: 16,
                  }}
                />
                <div className={`ap-action-field`}>
                  <div className={`ap-action-field__panel`}>
                    <Typography className={`ap-section__title ap-section__title--sm`}>
                      Approval Managers
                    </Typography>
                    <Typography className={`ap-section__description`}>
                      Assign managers to approve reservations made by users.
                    </Typography>
                  </div>
                  <div className={`ap-action-field__panel ap-action-field__panel--right`}>
                    <Button onClick={handleClickApprovalManager} className={`${RootClass}__button`}>
                      {configuration.managerIds.length
                        ? `Edit (${configuration.managerIds.length})`
                        : 'Add'}
                    </Button>
                  </div>
                </div>
              </div>

              <Divider
                orientation="vertical"
                flexItem
                className={`ap-section__v-divider ap-section__v-divider--thin`}
                style={{
                  marginLeft: 24,
                  marginRight: 32,
                }}
              />

              <div className={`${RootClass}__advance-panel ${RootClass}__advance-panel`}>
                <div className={`ap-action-field`}>
                  <div className={`ap-action-field__panel`}>
                    <Typography className={`ap-section__title ap-section__title--sm`}>
                      Add Additional Fields
                    </Typography>
                    <Typography className={`ap-section__description`}>
                      Create additional fields for users to fill out while making a reservation.
                    </Typography>
                  </div>
                  <div className={`ap-action-field__panel ap-action-field__panel--right`}>
                    <Button
                      onClick={handleClickAdditionalFields}
                      className={`${RootClass}__button`}
                    >
                      Add
                    </Button>
                  </div>
                </div>
                <div>
                  <Table className="ap-table c-res-additional-fields">
                    <TableHead>
                      <TableRow>
                        <TableCell className="ap-typography ap-typography--light">Name</TableCell>
                        <TableCell className="ap-typography ap-typography--light">
                          Field Type
                        </TableCell>
                        <TableCell className="ap-typography ap-typography--light">
                          Required
                        </TableCell>
                        <TableCell className="ap-typography ap-typography--light"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {configuration.additional_fields.map((field, i) => (
                        <TableRow key={i} onClick={e => handleEditAdditionalField(e, field, i)}>
                          <TableCell
                            style={{maxWidth: 320}}
                            align="left"
                            title={field.name}
                            className="ap-typography ap-typography--sm ap-ellipsis"
                          >
                            {field.name}
                          </TableCell>
                          <TableCell align="left" className="ap-typography ap-typography--sm">
                            {FieldTypeLookup[field.type]}
                          </TableCell>
                          <TableCell align="left" className="ap-typography ap-typography--sm">
                            {field.is_required ? 'Yes' : 'No'}
                          </TableCell>
                          <TableCell align="right" className="ap-typography ap-typography--sm">
                            <IconButton
                              size="small"
                              onClick={e => handleDeleteAdditionalField(e, i)}
                            >
                              <CloseIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </div>
          </Collapse>
        </div>
        <div className={`ap-footer ${!configuration.active && 'ap-disabled'}`}>
          <div className={`ap-footer__container ap-footer__container--right`}>
            <Button onClick={handleSave} className="ap-footer__button ap-footer__button--primary">
              Save
            </Button>
            <Button onClick={handleCancel} className="ap-footer__button">
              Cancel
            </Button>
          </div>
        </div>

        {/* MODALS */}
        <ReservationApprovalManager
          managerIds={configuration.managerIds}
          managerTemplateIds={configuration.managerTemplateIds}
          open={modal.modal === 'approval_manager'}
          onClose={handleCloseModal}
          onSave={handleSaveApprovalManager}
        />

        <ReservationLimitReservable
          open={modal.modal === 'limit_reservable'}
          onClose={handleCloseModal}
          selectedLimitReservable={configuration.limitReservable}
          onSave={handleSaveLimitReservable}
        />

        <ReservationAdditionalFields
          open={modal.modal === 'additional_fields'}
          edit={modal.params?.edit || false}
          data={modal.params?.data || {}}
          onClose={handleCloseModal}
          entity_id={_configuration.data.entity_id || ''}
          onSave={(e, field) => handleSaveAdditionalFields(e, field, modal.params?.index)}
        />

        {pconfiguration.isLoading && (
          <BlockingLoader>{saveLoaderMessage || 'Saving...'}</BlockingLoader>
        )}
        {_configuration.isLoading && <BlockingLoader>Loading configuration...</BlockingLoader>}
        {_configuration.data.additional_fields &&
          _configuration.data.additional_fields.length > 0 &&
          _configuration.data.additional_fields.map(
            field =>
              field.list_filters_attributes &&
              Array.isArray(field.list_filters_attributes) &&
              field.list_filters_attributes.map(filter => {
                const value = filter.field_id
                Cookies.remove('filters_removed_' + value)
                return null
              })
          )}
      </div>
      <PurchaseReservationPopup show={purchaseShow} onClose={handleClosePurchaseModal} />
    </ReservationErrorBoundary>
  )
}

export default ReservationConfiguration
